export default __webpack_public_path__ + "static/media/10-pharmacon.4f7b913b.png";